import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components/macro';

export const Container = styled.div`
    text-align: center;
    margin-top: 12px;
`;

export const Content1 = styled(Card)`
    display: inline-block;
`;

export const Content2 = styled.div`
    display: flex;
    padding: 4px 0;
`;

export const StyledImage = styled.img`
    height: 98px;
`;

export const TextContainer = styled.div`
    padding: 12px 20px 12px 0;
`;

export const Text1 = styled(Typography)`
    text-align: center;
    font-size: 1.5em;
    color: #517c06;
`;

export const Text2 = styled(Typography)`
    text-align: center;
    font-size: 2.3em;
    margin-top: 4px;
    color: #517c06;
`;